import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ReviewDashboardComponent} from './routing-review/review-dashboard/review-dashboard.component';
import {ReviewQueueComponent} from './routing-review/review-queue/review-queue.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {SiteDetailsComponent} from './site-details/site-details.component';
import {SiteListComponent} from './site-list/site-list.component';
import {MapToolComponent} from './map-tool/map-tool.component';
import {ApplicationListComponent} from './standby-generators/application-list/application-list.component';
import {HelpComponent} from './help/help.component';
import {NotificationComponent} from './routing-review/notification/notification.component';
import {ComplaintsListComponent} from './complaints/complaints-list.component';
import {canActivate} from './auth/user-config.service';

const routes: Routes = [
  {
    path: '', canActivate: [canActivate], children: [
      {path: 'dashboard', component: DashboardComponent},
      {path: 'site/list', component: SiteListComponent},
      {path: 'site/:id', component: SiteDetailsComponent},
      {path: 'complaints/list', component: ComplaintsListComponent},
      {path: 'maptool', component: MapToolComponent},
      {
        path: 'foia-search',
        loadComponent: () => import('./proximity-search/proximity-search.component').then(m => m.ProximitySearchComponent)
      },
      {
        path: 'foia-report',
        loadComponent: () => import('./proximity-search/proximity-report.component').then(m => m.ProximityReportComponent)
      },
      {path: 'help', component: HelpComponent},
      {
        path: 'solidwaste',
        loadComponent: () => import('./solid-waste/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'dww', data: {proxyUrl: "dww_proxy/DWW/index.jsp"},
        loadComponent: () => import('./drinking-water-watch/proxy-iframe.component').then(m => m.ProxyIframeComponent)
      },
      {
        path: 'contactmanager',
        loadComponent: () => import('./contacts/contact-manager/contact-manager.component').then(m => m.ContactManagerComponent)
      },
      {
        path: 'storagetanks/reports',
        loadComponent: () => import('./storage-tanks-report/storage-tanks-report.component').then(m => m.StorageTanksReportComponent)
      },
      //   ]
      // },
      // {
      //   path: 'applications', component: RootComponent, children: [
      {path: 'applications/standby', data: {type: 'standbygenerator/permits'}, component: ApplicationListComponent},
      {
        path: 'applications/standbyannualreports',
        data: {type: 'standbygenerator/annual_reports'},
        component: ApplicationListComponent
      },
      {path: 'applications/pesticides', data: {type: 'pesticides/noa'}, component: ApplicationListComponent},
      //   ]
      // },
      {path: 'beach', loadChildren: () => import('./beaches/beaches.module').then(m => m.BeachesModule)},
      {
        path: 'permit', data: {showSearch: false}, children: [
          {path: 'dashboard', component: ReviewDashboardComponent},
          {path: 'review', component: ReviewQueueComponent},
          {path: 'listall', component: ReviewQueueComponent},
          {path: 'notification/onestop', component: NotificationComponent, data: {type: 'onestop/permits'}},
          {path: 'notification/standby', component: NotificationComponent, data: {type: 'standbygenerator/permits'}}
        ]
      },
      {path: 'permits', redirectTo: 'permit'},
      {path: '**', redirectTo: 'dashboard'}
    ]
  }
  // {path: '', loadChildren: () => import('./appjs/appjs.module').then(m => m.AppjsModule)},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
